/** @prettier */
import React from "react";
import classNames from "classnames";
import { TestRunnerDispatch, SummaryState } from "./testRunnerState";
import { TestSummaryItem } from "../View/TestSummaryBar";

export type TestSummaryBarProps = {
    dispatch: TestRunnerDispatch;
    questionNumber: number;
    totalQuestionCount: number;
    summaryState: SummaryState[];
};
const TestSummaryBar = ({
    dispatch,
    questionNumber,
    totalQuestionCount,
    summaryState,
}: TestSummaryBarProps) => (
    <div className="tr-summary">
        <div className="tr-summary-item">Review</div>
        {Array.from({ length: totalQuestionCount }, (_, i) => (
            <TestSummaryItem
                key={i}
                index={i}
                current={i === questionNumber}
                dispatch={dispatch}
                isFlagged={summaryState[i].flagged}
                result={!summaryState[i].answered ? "UNANSWERED" : undefined}
            />
        ))}
        <div
            className={classNames("tr-summary-item", {
                active: questionNumber === totalQuestionCount,
            })}
        >
            <button
                disabled={questionNumber === totalQuestionCount}
                title={`Go to the test review`}
                onClick={() => dispatch({ event: "gotoReview" })}
            >
                Finish
            </button>
        </div>
    </div>
);
export default TestSummaryBar;
